import { render, staticRenderFns } from "./kycInfo.vue?vue&type=template&id=41a7dbbe&scoped=true&"
import script from "./kycInfo.vue?vue&type=script&lang=js&"
export * from "./kycInfo.vue?vue&type=script&lang=js&"
import style0 from "./kycInfo.vue?vue&type=style&index=0&id=41a7dbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a7dbbe",
  null
  
)

export default component.exports